export default "__VITE_ASSET__d013c763__"